/**
 * History
 *   08Jan2019 (SW)
 *    - ADO 15834: Operator logging into Handheld software
 */

import appConfig from "../../app-config";
const FEATURE_KEY = `feature_${appConfig.VUE_APP_COOKIE_NAME}`;
const SO_VERSION_IN_USE_KEY = `so_version_in_use_${appConfig.VUE_APP_COOKIE_NAME}`;

const FeatureStorage = {
  getItems() {
    return JSON.parse(localStorage.getItem(FEATURE_KEY));
  },
  saveItems(features) {
    return localStorage.setItem(FEATURE_KEY, JSON.stringify(features));
  },

  saveSalesOrderVersionInUse(soVersionInUse) {
    return localStorage.setItem(SO_VERSION_IN_USE_KEY, soVersionInUse);
  },

  getSalesOrderVersionInUse() {
    return localStorage.getItem(SO_VERSION_IN_USE_KEY) || "V1";
  },

  checkPermission(featureCode, mode) {
    // if no featureCode is specified in the route, then it's a free pass
    if (!featureCode) return true;

    let accessValid = false;
    if (Array.isArray(featureCode)) {
      featureCode.forEach((item) => {
        let matchedItem = FeatureStorage.getItems().filter(
          (x) =>
            x.ApplicationFeatureCode.trim() == item &&
            (x.Type == "Screen" ||
              x.Type == "Settings Screen" ||
              x.Type == "Screen Setting" ||
              x.Type == "Grid Report" ||
              x.Type == "Transaction Report" ||
              x.Type == "Formatted Report")
        );

        if (mode == "create" || mode == "edit") {
          if (matchedItem.length > 0 && matchedItem[0].WritePermission == "Y")
            accessValid = true;
        } else if (mode == "review") {
          if (matchedItem.length > 0 && matchedItem[0].ReadPermission == "Y")
            accessValid = true;
        }
      });
    } else {
      let matchedItem = FeatureStorage.getItems().filter(
        (x) =>
          x.ApplicationFeatureCode.trim() == featureCode &&
          (x.Type == "Screen" ||
            x.Type == "Settings Screen" ||
            x.Type == "Screen Setting" ||
            x.Type == "Grid Report" ||
            x.Type == "Transaction Report" ||
            x.Type == "Formatted Report")
      );

      if (mode == "create" || mode == "edit") {
        if (matchedItem.length > 0 && matchedItem[0].WritePermission == "Y")
          accessValid = true;
      } else if (mode == "review") {
        if (matchedItem.length > 0 && matchedItem[0].ReadPermission == "Y")
          accessValid = true;
      }
    }

    return accessValid;
  },

  checkRouteAccess(featureCode) {
    // eslint-disable-next-line no-console
    // this.$logger.debug(
    //   "FeatureStorage.getItems()",
    //   FeatureStorage.getItems(),
    //   featureCode,
    //   type
    // );

    if (!featureCode) return true;

    let accessValid = FeatureStorage.getItems().some(
      (x) =>
        x.ApplicationFeatureCode.trim() == featureCode &&
        // x.Type == type &&
        (x.ReadPermission == "Y" || x.WritePermission == "Y")
    );

    // eslint-disable-next-line no-console
    // this.$logger.debug(
    //   `[Type] ${type} [Feature] ${featureCode} [Access] ${accessValid}`
    // );
    return accessValid;
  },
  // eslint-disable-next-line
  getUserType(featureCode) {
    var items = FeatureStorage.getItems();
    return items[0].ApplicationUserTypeCode;
  },
  clear() {
    return localStorage.removeItem(FEATURE_KEY);
  },
};

export { FeatureStorage };
